package com.arena_web.data.dto

import kotlinx.serialization.Serializable

/** One earned award. `sportId`/`rank` are null for the global welcome award,
 *  `eventId`/`eventTitle` are null for awards not tied to an event. Both card
 *  faces come pre-rendered from storage (like card art) — the client only
 *  localizes the text label from `category` + `rank` + sport. */
@Serializable
data class UserAwardDto(
    val id: String,
    val category: String,
    val rank: Int? = null,
    val sportId: String? = null,
    val imageUrl: String,
    val backImageUrl: String,
    val eventId: String? = null,
    val eventTitle: String? = null,
    val earnedAt: String,
)

object AwardCategories {
    const val WELCOME = "WELCOME"
    const val SCORER = "SCORER"
    const val ASSIST = "ASSIST"
}
